export default class contactManager {

    constructor() {

        // 送信可・不可のフラグ
        this.status = {
            flg: false,
            consensCheck: false,
        }

        // form要素
        this.form = document.getElementById("js__form");


        // 入力必須のクラス
        this.check = document.querySelectorAll(".js__required");
        // エラーメッセージ
        // this.errorMsg = document.querySelectorAll(".error-text");

        // エラー表示 背景赤
        this.error = document.getElementsByClassName('is-error');
        this.errorKana = document.getElementsByClassName('error-kana');
        this.errorEmail = document.getElementsByClassName('error-email');
        this.errorPhone = document.getElementsByClassName('error-phone');

        // 送信ボタン
        this.submitBtn = document.getElementById("js__submit");
        // リセットボタン
        this.removeBtn = document.getElementById("js__remove");

        this.target;




    }

    init() {

        // input要素 Enterキーでsubmitしない
        this.enterInvalid();
        
        // フォーカスを外した時にチェック
        this.blur();


        // select,checkboxの値が変化した時にチェック
        this.change();

        //送信ボタン
        this.submitBtn.onclick = () => {
            // 入力必須の要素チェック
            for (let i = 0; i < this.check.length; i++) {
                let _index = i;
                this.target = this.check[_index];
                this.errorSet();
                this.consensCheck();
                this.contactTypeSelectCheck();
                this.nameCheck();
                this.kanaCheck();
                this.emailCheck();
                this.emailConfirmCheck();
                this.phoneCheck();
                this.inquiryCheck();
                // エラーがなければフラグを変更
                this.validate();
            }
            // エラーの場合フォームの上にスクロールする
            if (!this.status.flg) {
                TweenLite.to(window, 0.2, {
                    scrollTo: {
                        y: this.form.getBoundingClientRect().top + window.pageYOffset,
                        autoKill: false
                    }
                });
                return false;
            }
        }
        //送信ボタンと同じ？
        // this.form.onsubmit = () => {
        //     // 入力必須の要素チェック
        //     for (let i = 0; i < this.check.length; i++) {
        //         let _index = i;
        //         this.target = this.check[_index];
        //         this.errorSet();
        //         this.consensCheck();
        //         this.contactTypeSelectCheck();
        //         this.nameCheck();
        //         this.kanaCheck();
        //         this.emailCheck();
        //         this.emailConfirmCheck();
        //         this.phoneCheck();
        //         this.inquiryCheck();
        //         // エラーがなければフラグを変更
        //         this.validate();
        //     }
        //     // エラーの場合フォームの上にスクロールする
        //     if (!this.status.flg) {
        //         TweenLite.to(window, 0.2, {
        //             scrollTo: {
        //                 y: this.form.getBoundingClientRect().top + window.pageYOffset,
        //                 autoKill: false
        //             }
        //         });
        //         return false;
        //     }
        // }


        // リセットボタン
        this.removeBtn.addEventListener('click', () => {
            // 入力必須の要素チェック
            for (let i = 0; i < this.check.length; i++) {
                let _index = i;
                this.target = this.check[_index];
                this.reset();
            }
            // プライバシーポリシーに同意 チェックボックス用 エラーメッセージを空にする
            let _checkbox = document.getElementById('consens');
            _checkbox.nextElementSibling.lastElementChild.textContent = '';
        });

    }


    enterInvalid(){
        this.input = this.form.querySelectorAll('input');
        for (let i = 0; i < this.input.length; i++) {
            this.input[i].addEventListener('keydown', (event)=>{
                if(event.key === 'Enter') {
                    event.preventDefault();
                }
            });
        }
    }

    // フォーカスを外した時にチェック
    blur() {
        for (let i = 0; i < this.check.length; i++) {
            let _index = i;
            this.check[_index].addEventListener('blur', () => {
                this.target = this.check[_index];
                this.errorSet();
                this.nameCheck();
                this.kanaCheck();
                this.emailCheck();
                this.emailConfirmCheck();
                this.phoneCheck();
                this.inquiryCheck();
            });
        }
    }


    // select,checkboxの値が変化した時にチェック
    change() {
        for (let i = 0; i < this.check.length; i++) {
            let _index = i;
            this.check[_index].addEventListener('change', () => {
                this.target = this.check[_index];
                this.errorSet();
                this.consensCheck();
                this.contactTypeSelectCheck();
            });
        }
    }

    // チェックボックス
    consensCheck() {
        let _id = this.target.getAttribute("id");
        let _val = this.target.checked;

        if (_id.match(/consens/g)) {
            if (_val === false) {
                this.target.nextElementSibling.lastElementChild.textContent = "※プライバシーポリシーの同意は必須項目です";
                this.status.consensCheck = false;
            } else if (_val === true) {
                this.target.nextElementSibling.lastElementChild.textContent = "";
                this.status.consensCheck = true;
            }
        }
    }

    // お問い合わせの種類
    contactTypeSelectCheck() {
        let _id = this.target.getAttribute("id");
        let _val = this.target.value;

        if (_id.match(/contact_type/g)) {
            if (_val === "") {
                this.errorSet();
                TweenMax.set(this.target, {className: "+=is-error"});
                this.target.parentNode.nextElementSibling.textContent = "※お問い合わせの種類を選択してください";
            }
        }
    }

    // 名前
    nameCheck() {
        let _id = this.target.getAttribute("id");
        let _val = this.target.value;

        if (_id.match(/name/g)) {
            if (_val === "") {
                this.errorSet();
                this.target.nextElementSibling.textContent = "※お名前を入力して下さい";
            }
        }
    }

    // カタカナ
    kanaCheck() {
        let _id = this.target.getAttribute("id");
        let _val = this.target.value;

        if (_id.match(/name_kana/g)) {
            if (_val === "" && !this.target.classList.contains('js__no-required')) {
                this.errorSet();
                this.target.nextElementSibling.textContent = "※お名前（カナ）を入力してください";
            } else {
                // if(!_val.match(/^[ぁ-ろわをんー 　\r\n\t]*$/)){
                if (!_val.match(/^[ァ-ンヴー 　\r\n\t]*$/)) {
                    this.reset();
                    TweenMax.set(this.target, {className: "+=is-error-kana"});
                    TweenMax.set(this.target.nextElementSibling, {className: "+=is-error"});
                    this.target.nextElementSibling.textContent = "※カタカナで入力してください";
                }
            }
        }
    }

    emailCheck() {
        let _id = this.target.getAttribute("id");
        let _val = this.target.value;


        if (_id.match(/form-email/g)) {
            if (_val === "" && !this.target.classList.contains('js__no-required')) {
                this.errorSet();
                this.target.nextElementSibling.textContent = "※メールアドレスを入力してください";
            } else {
                if (!_val.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
                    this.reset();
                    TweenMax.set(this.target, {className: "+=is-error-email"});
                    TweenMax.set(this.target.nextElementSibling, {className: "+=is-error"});
                    this.target.nextElementSibling.textContent = "※メールアドレスの形式が異なります";
                }
            }
        }
    }

    emailConfirmCheck() {
        let _id = this.target.getAttribute("id");
        let _val = this.target.value;


        if (_id.match(/mail_conf/g)) {
            if (_val === "" && !this.target.classList.contains('js__no-required')) {
                this.errorSet();
                this.target.nextElementSibling.textContent = "※メールアドレスを入力してください";
            } else {
                if (!_val.match(document.getElementById("form-email").value)) {
                    this.reset();
                    TweenMax.set(this.target, {className: "+=is-error-email"});
                    TweenMax.set(this.target.nextElementSibling, {className: "+=is-error"});
                    this.target.nextElementSibling.textContent = "※メールアドレスが一致しません";
                }
            }
        }
    }


    phoneCheck() {
        let _id = this.target.getAttribute("id");
        let _val = this.target.value.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi, '');

        if (_id.match(/form-tel/g)) {
            if (_val === "" && !this.target.classList.contains('js__no-required')) {
                this.errorSet();
                this.target.nextElementSibling.textContent = "※電話番号を入力してください";
            } else if (_val.length !== 10 && _val.length !== 11) {
                this.reset();
                TweenMax.set(this.target, {className: "+=is-error-phone"});
                TweenMax.set(this.target.nextElementSibling, {className: "+=is-error"});
                this.target.nextElementSibling.textContent = "※電話番号を正しく入力して下さい";
            } else {
                if (!_val.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/)) {
                    this.reset();
                    TweenMax.set(this.target, {className: "+=is-error-phone"});
                    TweenMax.set(this.target.nextElementSibling, {className: "+=is-error"});
                    this.target.nextElementSibling.textContent = "※電話番号を正しく入力して下さい";
                }
            }
        }
    }

    inquiryCheck() {
        let _id = this.target.getAttribute("id");
        let _val = this.target.value;

        if (_id.match(/contact_content/g)) {
            if (_val === "") {
                this.errorSet();
                this.target.nextElementSibling.textContent = "※お問い合わせ内容を入力して下さい";
            }
        }
    }

    // エラー表示セット
    errorSet() {
        this.reset();
        if (this.target.value === "" && !this.target.classList.contains('js__no-required')) {
            if (this.target.parentNode.nextElementSibling !== null) {
                TweenMax.set(this.target.parentNode.nextElementSibling, {className: "+=is-error"});
            } else {
                TweenMax.set([this.target, this.target.nextElementSibling], {className: "+=is-error"});
            }
        }
    }


    // エラー表示リセット
    reset() {
        if (this.error != null) {
            // ファイルアップロードの部分のみディレクトリ構成が異なるため
            if (this.target.parentNode.nextElementSibling !== null) {
                TweenMax.set(this.target.parentNode.nextElementSibling, {className: "-=is-error"});
                if(this.target.nodeType == 1){
                    TweenMax.set(this.target, {className: "-=is-error"});
                }
            } else {
                TweenMax.set([this.target, this.target.nextElementSibling], {className: "-=is-error"});
            }
        }
        if (this.errorKana != null) {
            TweenMax.set(this.target, {className: "-=is-error-kana"});
        }
        if (this.errorEmail != null) {
            TweenMax.set(this.target, {className: "-=is-error-email"});
        }
        if (this.errorPhone != null) {
            TweenMax.set(this.target, {className: "-=is-error-phone"});
        }
    }


    // エラーがなければフラグを変更
    // this.status.flg = true;
    validate() {
        if (document.getElementsByClassName('is-error').length > 0
            || document.getElementsByClassName('is-error-kana').length > 0
            || document.getElementsByClassName('is-error-email').length > 0
            || document.getElementsByClassName('is-error-phone').length > 0
            || this.status.consensCheck === false) {
            this.status.flg = false;
        } else {
            this.status.flg = true;
        }
    }


}

